import React, { useState, useEffect, memo } from 'react';
import {
  Box,
  Icon,
  Typography,
  ButtonBase,
  Drawer,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import { useLocation } from 'react-router-dom';

import MenuItem from '../../../components/MenuItem';
import useStyles from './styles';
import Loading from './Loading';
import { useAppointments } from '../context';

const SideMenu = () => {
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [loading, setLoading] = useState(true);
  const [variantDrawer, setVariantDrawer] = useState('permanent');
  const { showSideMenu, handleShowSideMenu, infos } = useAppointments();

  useEffect(() => {
    if (infos.loaded) {
      setLoading(false);
    }
  }, [infos.loaded]);

  // Define o tipo do menu de acordo com o tamanho da tela
  useEffect(() => {
    handleShowSideMenu(!isSmallScreen);
    setVariantDrawer(isSmallScreen ? 'temporary' : 'permanent');
  }, [isSmallScreen, handleShowSideMenu]);

  useEffect(() => {
    if (variantDrawer === 'temporary') {
      handleShowSideMenu(false);
    }
  }, [location, variantDrawer, handleShowSideMenu]);

  return (
    <Drawer
      className={`${classes.container} ${showSideMenu ? 'open' : 'close'}`}
      classes={{ paper: classes.drawerPaper }}
      anchor="right"
      open={showSideMenu}
      onClose={handleShowSideMenu}
      variant={variantDrawer}
    >
      {loading ? (
        <Loading />
      ) : (
        <>
          <Box className="header-bar">
            <ButtonBase
              className="toggle-side-menu"
              onClick={handleShowSideMenu}
            >
              <Typography
                className="toggle-side-menu-text"
                variant="caption"
                noWrap
              >
                {`${showSideMenu ? 'Esconder' : 'Mostrar'} navegação`}
              </Typography>
              <Icon
                className={`toggle-side-menu-icon ${
                  showSideMenu ? 'opened' : ''
                }`}
              >
                menu_open
              </Icon>
            </ButtonBase>
          </Box>
          {showSideMenu && (
            <>
              <Box className="modules-container">
                {!!infos?.html && (
                  <MenuItem
                    path="/appointments"
                    title="Sobre os agendamentos"
                    icon="info"
                  />
                )}
                <MenuItem
                  path="/appointments/history"
                  title="Meus agendamentos"
                  icon="date_range"
                />
                <MenuItem
                  path="/appointments/new"
                  title="Agendar horário"
                  icon="schedule"
                  withSubPages
                />
                {!!infos?.term && (
                  <MenuItem
                    href={infos.term}
                    target="_blank"
                    title="Termos e condições"
                    icon="assignment"
                  />
                )}
              </Box>
            </>
          )}
        </>
      )}
    </Drawer>
  );
};

export default memo(SideMenu);
